import axios from 'axios';
import router from '@/router'

let http = axios.create({
    validateStatus: false,
});

const setApiUrl = (environment) => {
    let item = window.config.environments.find(item => item.value === environment);
    if (item) {
        http.defaults.baseURL = item.url;
    }
}

http.interceptors.request.use(
    config => {
        return config
    },
    error => {
        return Promise.reject(error)
    }
)

http.interceptors.response.use(
    response => {
        return response
    },
    error => {
        if(error.response){
            if(error.response.status === 401) {
                router.push({name: 'login'})
                return Promise.resolve()
            }
        }
        return Promise.reject(error)
    })
http.interceptors.request.use((request) => {  
    // Verificar se é login SSO (flag no localStorage)
    const isSSOLogin = localStorage.getItem('universe-sso-flag') === 'true';
    
    if (isSSOLogin) {
        // Para SSO: não adicionamos Authorization header, o backend valida automaticamente via cookie HttpOnly
        // Mas precisamos enviar credenciais para o cookie ser enviado
        request.withCredentials = true;
    } else {
        // Para login tradicional: usar token do sessionStorage para o Authorization header
        let token = sessionStorage.getItem('universe-sid');
        
        if (token) {
            request.headers['Authorization'] = `Bearer ${token}`;
        } else {
            request.headers['Authorization'] = '';
        }
    }
    
    return request;
});

const setBearerToken = (token) => {
    http.interceptors.request.use((request) => {
        request.headers['Authorization'] = token ? `Bearer ${token}` : '';
        return request;
    });
}

export default http;
export { http, setBearerToken, setApiUrl };
